import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule } from '@pro-connect/shared';
import { IProEducationTraining } from '../../models/pro-education-training';
import { ProEduTraFaqComponent } from '../pro-edu-tra-faq/pro-edu-tra-faq.component';

@Component({
  selector: 'app-pro-edu-tra-info',
  templateUrl: './pro-edu-tra-info.component.html',
  styleUrls: ['./pro-edu-tra-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule, ProEduTraFaqComponent],
})
export class ProEduTraInfoComponent {
  public trainingDetails = input.required<IProEducationTraining | null>();
}
